$(document).on('click', '.page-nav a.bar-back', function(event){
	if($('.page-nav main .part-left').is(':hidden')){
		event.preventDefault()
		$('.page-nav').removeAttr('data-nav')
	}
})
